import { Failure } from '~/infrastructure/mam/ApiClient';
import * as React from 'react';

import { Link } from '~/UI/Button';
import Heading from '~/UI/Heading/Heading';

import styles from '../NotFoundErrorPage/styles.less';

const ServerErrorPage = ({ error, title }: { error?: Failure<any> | null; title?: string | null }) => {
	const normalizedMessagae = !title
		? Array.from(error?.codes || ['500']).map((errorCode) => (
				<span key={errorCode}>
					{errorCode}
					<br />
				</span>
		  ))
		: null;

	return (
		<div className={styles.content}>
			<div className={styles.in}>
				<Heading>
					An error has occurred:
					<br />
					{normalizedMessagae}
				</Heading>
				{title && <p className='mb-10'>{title}</p>}
				<p>
					{!title && (
						<>
							Sorry, it seems that something is broken.
							<br />
						</>
					)}
					Here are a few links that may be helpful:
					<br />
					<Link to='/product-groups/'>Search</Link>
					<i className={styles.space}> • </i>
					<Link to='/product-groups/#product-list'>Product list</Link>
					<i className={styles.space}> • </i>
					<Link href='https://www.cogvio.com/'>www.cogvio.com</Link>
				</p>
			</div>
		</div>
	);
};

export default React.memo(ServerErrorPage);
